export default __webpack_public_path__ + "static/media/unrectified.78a4d848.png";